module.exports = __webpack_public_path__ + "img/guide.9fd94764.png";